<template>
    <div class="flex gap-2">
        <v-btn icon text color="teal" :href="`https://hub.cuprolli.ro/docs/configurator/${downloadLink}.pdf`"
            :download="downloadFilename" target="_blank">
            <v-icon>mdi-cloud-download</v-icon>
        </v-btn>
        <v-dialog v-if="!euVersion" v-model="visibleMoveModal" max-width="360px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon text color="teal" v-bind="attrs" v-on="on">
                    <v-icon>mdi-file-document-plus</v-icon>
                </v-btn>
            </template>
            <v-card class="p-4">
                <h6 class="text-xl mb-4">Vrei sa treci oferta <span class="font-bold">{{ item.id_cerere }}</span> in
                    <span class="font-bold">Oferte
                        HUB</span>?
                </h6>
                <div class="flex flex-row justify-end gap-2 px-6 pb-4">
                    <v-btn color="blue-grey" class="uppercase" dark large
                        @click="visibleMoveModal = false">Anuleaza</v-btn>
                    <v-btn color="teal" dark class="uppercase" large :loading="loadingMoveToOferteGarduri"
                        @click="moveToOferte">Trece in oferte HUB</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { FRAME_THICKNESS } from '@/utils/fenceModules';
import { modelImageSlug } from '@/utils/fenceGeometry';

export default {
    props: {
        item: Object,
        user: Object,
        countyId: {
            type: Number,
            default: 0
        },
        today: String,
        euVersion: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visibleMoveModal: false,
            prices: {
                p_rama: 1.2, // %
                pp: 145, // eur
                pa: 35, // eur
                pas: 35, // eur
                pap: 145, // eur
            },
            new_prices: {
                p_rama: 1.28, // %
                pp: 265, // eur
                pa: 45, // eur
                pas: 45, // eur
                pap: 115, // eur
            },
            new_new_prices: {
                p_rama: 1.245, // %
                pp: 235, // eur
                pa: 75, // eur
                pas: 75, // eur
                pap: 115, // eur
            },
            newest_prices: {
                p_rama: 1.245, // %
                pp: 235, // eur
                pa: 100, // eur
                pas: 100, // eur
                pap: 210, // eur
            },
            newest_prices2: {
                p_rama: 1.191, // %
                pp: 236, // eur
                pa: 115, // eur
                pas: 115, // eur
                pap: 247, // eur
            },
            newest_prices3: {
                p_rama: 1.27, // %
                pp: 237, // eur
                pa: 126, // eur
                pas: 126, // eur
                pap: 254, // eur
            },
            newest_prices4: {
                p_rama: 35, // %
                pp: 212, // eur
                pa: 122, // eur
                pas: 122, // eur
                pap: 252, // eur
            },
            partener_prices: {
                add_p: 7, // %
                p_rama: 1.233, // %
                pp: 228, // eur
                pa: 103, // eur
                pas: 103, // eur
                pap: 178, // eur
            },
            new_partener_prices: {
                add_p: 7, // %
                p_rama: 1.233, // %
                pp: 228, // eur
                pa: 128, // eur
                pas: 128, // eur
                pap: 273, // eur
            },
            suprafata_limita_panou: 0.1,
            suprafata_limita_pp: 1.9,
            suprafata_limita_pa: 6.7,
            suprafata_limita_pa_pp_included: 4.8,
        }
    },
    computed: {
        ...mapState(["loadingMoveToOferteGarduri"]),
        downloadLink() {
            if (this.euVersion) {
                return `eu/zaun_angebot_${this.item.id_cerere}`
            } else {
                return `oferta_gard_${this.item.id_cerere}_${this.item.client_obj.name}_${this.item.client_obj.surname}`
            }
        },
        downloadFilename() {
            if (this.euVersion) {
                return `oferta_gard_eu_${this.item.id_cerere}`
            } else {
                return `oferta_gard_${this.item.id_cerere}_${this.item.client_obj.name}_${this.item.client_obj.surname}`
            }
        }
    },
    methods: {
        /**
         * An EU request carries a catalogue code (V30R, H60/100/20), whose renders are named the way
         * EditModul names them: v30r_panou.png, v30r_batanta_dubla.png. There are no framed-panel
         * or _pp renders, so those fall back to the plain picture of their kind. The older RO
         * requests only know a direction and keep the orizontal_* / vertical_* pictures.
         */
        offerImage(modelName, kind, legacyKind) {
            return this.item.country
                ? `${modelImageSlug(modelName)}_${kind}.png`
                : `${modelName}_${legacyKind}.png`;
        },
        raportSuprafataMin(suprafata, minsuprafata) {
            if (suprafata < minsuprafata) {
                let raport = 2 - suprafata / minsuprafata
                raport = raport > 1.3 ? 1.3 : raport
                return raport;
            } else {
                return 1;
            }
        },
        nrProfilePoarta(dim, panel) {
            let dimensiune = dim - FRAME_THICKNESS * 2;
            let nr =
                (dimensiune + panel.selectedProfil) /
                (panel.selectedProfil + Number(panel.gol_calculat)) -
                1;
            let mp = 1;
            if (panel.selectedSize == "medium") {
                mp = 2;
            } else if (panel.selectedSize == "large") {
                mp = 3;
            }
            return Math.ceil(nr - mp);
        },
        golPoarta(dim, nrProfile, profil) {
            let dimensiune = dim - FRAME_THICKNESS * 2;
            let gol = (dimensiune - nrProfile * profil) / (nrProfile + 1);
            return gol;
        },
        getFormatedGardObj(gard, prices, id_cerere, price) {
            let arr = [];
            let priceVar;
            // Legacy leads   
            if (Number(id_cerere) >= 27700) {
                priceVar = this.newest_prices4;
            } else if (Number(id_cerere) >= 11834) {
                priceVar = this.newest_prices3;
            } else if (Number(id_cerere) >= 8838) {
                priceVar = this.newest_prices2;
            } else if (id_cerere >= "6446") {
                priceVar = this.newest_prices;
            } else if (id_cerere >= "4216") {
                priceVar = this.new_new_prices;
            } else if (id_cerere >= "2759") {
                priceVar = this.new_prices;
            } else {
                priceVar = this.prices;
            }

            let pricePanouri = gard.configuration.panouri.panelFrame
                ? prices ? Number(prices.price_panel_frame) : price + priceVar.p_rama
                : prices ? Number(prices.price_panel) : price

            let suprafataPanou = (
                gard.suprafataPanouri / gard.configuration.panouri.buc
            ).toFixed(3);
            let costModul = (
                suprafataPanou *
                pricePanouri *
                this.raportSuprafataMin(suprafataPanou, this.suprafata_limita_panou)
            ).toFixed(2);
            let gol = Math.round(gard.panel.gol_calculat * 10) / 10;
            let marja = 0;
            let modelName = this.item.country ? gard.model : (gard.model == "orizontal" || gard.model == "horizontal") ? "orizontal" : "vertical";

            if (gard.configuration.panouri.is) {
                // One obj for all panels
                let panelObj = {
                    nr: 1,
                    tip: gard.configuration.panouri.panelFrame ? "Panou_rama" : "Panou",
                    model: gard.model == "horizontal" ? 1 : 2,
                    denumire_model: modelName,
                    latime_profil: gard.panel.selectedProfil,
                    distanta_gol: gol.toFixed(1),
                    gol_afisat: "",
                    p_gol: "",
                    nr_profile: gard.panel.nrProfile,
                    grosime_rama: FRAME_THICKNESS,
                    filename: this.offerImage(
                        modelName,
                        "panou",
                        gard.configuration.panouri.panelFrame ? "panou_rama" : "panou"
                    ),
                    pret: pricePanouri,
                    latime: gard.lPanou.toFixed(0),
                    inaltime: Number(gard.hPanou) * 1000,
                    buc: gard.configuration.panouri.buc,
                    suprafata: suprafataPanou,
                    cost_modul: costModul,
                    cost_total: (costModul * gard.configuration.panouri.buc).toFixed(2),
                    marja: marja,
                    pret_modul: (
                        Number(costModul) * gard.configuration.panouri.buc +
                        Number(costModul) * gard.configuration.panouri.buc * (marja / 100)
                    ).toFixed(2),
                    min_gol: "10",
                };
                arr.push(panelObj);
            }

            let nr_crt = 2;

            let pricePP = prices ? Number(prices.price_gate_pedestrian) : price + priceVar.pp;
            let pricePA = prices ? Number(prices.price_gate_swing) : price + priceVar.pa;
            let pricePAS = prices ? Number(prices.price_gate_slide) : price + priceVar.pas;
            let pricePAP = prices ? (prices.price_gate_selfsupport ? Number(prices.price_gate_selfsupport) : Number(prices.price_gate_selfsupporting)) : price + priceVar.pap;

            // One obj for each poarta pietonala
            if (gard.configuration.poarta_p.is) {
                for (let i = 0; i < gard.configuration.poarta_p.items.length; i++) {
                    let lPoarta = gard.configuration.poarta_p.items[i].latime_gol;
                    let hPoarta = gard.dimensions.ht * 1000;
                    let suprafataPP = ((lPoarta / 1000) * hPoarta) / 1000;
                    let costPoarta = (
                        suprafataPP *
                        pricePP *
                        this.raportSuprafataMin(suprafataPP, this.suprafata_limita_pp)
                    ).toFixed(2);
                    let nrProfile = this.nrProfilePoarta(hPoarta, gard.panel);
                    let golPoarta = this.golPoarta(
                        hPoarta,
                        nrProfile,
                        gard.panel.selectedProfil
                    );

                    let poartaPObj = {
                        nr: nr_crt,
                        tip: "Poarta_mica",
                        model: gard.model == "horizontal" ? 1 : 2,
                        denumire_model: modelName,
                        latime_profil: gard.panel.selectedProfil,
                        distanta_gol: golPoarta.toFixed(1),
                        gol_afisat: "",
                        p_gol: "",
                        nr_profile: nrProfile,
                        filename: this.offerImage(modelName, "pietonala", "poarta_mica"),
                        pret: pricePP,
                        latime: lPoarta,
                        inaltime: hPoarta,
                        buc: 1,
                        suprafata: suprafataPP,
                        cost_modul: costPoarta,
                        cost_total: costPoarta,
                        marja: marja,
                        pret_modul: (
                            Number(costPoarta) +
                            costPoarta * (marja / 100)
                        ).toFixed(2),
                        min_gol: "10",
                        grosime_rama: FRAME_THICKNESS,
                    };
                    arr.push(poartaPObj);
                    nr_crt++;
                }
            }

            // One obj for each poarta auto
            if (gard.configuration.poarta_a.is) {
                for (let i = 0; i < gard.configuration.poarta_a.items.length; i++) {
                    let lPoarta = gard.configuration.poarta_a.items[i].latime_gol;
                    let tip_poarta_mare = gard.configuration.poarta_a.items[i].tip;
                    if (tip_poarta_mare == "batanta") {
                        tip_poarta_mare += "_dubla"
                    }

                    let hPoarta = gard.dimensions.ht * 1000;
                    let pp_included = gard.configuration.poarta_a.items[i].pp_included;
                    let latime_pp = gard.configuration.poarta_a.items[i].latime_pp;

                    let suprafataPA = Number(lPoarta / 1000 * hPoarta / 1000);
                    let suprafataPPIncluded = pp_included
                        ? Number(latime_pp / 1000 * hPoarta / 1000)
                        : 0;

                    let costPA = 0;
                    let costPP = 0;

                    if (pp_included) {
                        const suprafataPAPP = suprafataPA - suprafataPPIncluded;
                        costPA = (
                            suprafataPAPP *
                            (tip_poarta_mare == "autoportanta" ? pricePAP : tip_poarta_mare == "culisanta" ? pricePAS : pricePA) *
                            this.raportSuprafataMin(suprafataPAPP, this.suprafata_limita_pa_pp_included)).toFixed(2);
                        costPP =
                            (suprafataPPIncluded *
                                pricePP *
                                this.raportSuprafataMin(
                                    suprafataPPIncluded,
                                    this.suprafata_limita_pp
                                )).toFixed(2);
                    } else {
                        costPA =
                            suprafataPA *
                            (tip_poarta_mare == "autoportanta" ? pricePAP : tip_poarta_mare == "culisanta" ? pricePAS : pricePA) *
                            this.raportSuprafataMin(suprafataPA, this.suprafata_limita_pa);
                    }

                    let costPoarta = (Number(costPA) + Number(costPP)).toFixed(2);

                    let nrProfile = this.nrProfilePoarta(hPoarta, gard.panel);
                    let golPoarta = this.golPoarta(
                        hPoarta,
                        nrProfile,
                        gard.panel.selectedProfil
                    );

                    let poartaAObj = {
                        nr: nr_crt,
                        tip: "Poarta_mare",
                        model: gard.model == "horizontal" ? 1 : 2,
                        pp_included: pp_included,
                        denumire_model: modelName,
                        latime_profil: gard.panel.selectedProfil,
                        distanta_gol: golPoarta.toFixed(1),
                        gol_afisat: "",
                        p_gol: "",
                        nr_profile: nrProfile,
                        filename: this.offerImage(
                            modelName,
                            tip_poarta_mare,
                            `poarta_mare${tip_poarta_mare == "autoportanta"
                                ? 3
                                : tip_poarta_mare == "culisanta"
                                    ? 2
                                    : ""
                            }${pp_included ? "_pp" : ""}`
                        ),
                        pret: tip_poarta_mare == "autoportanta" ? pricePAP : tip_poarta_mare == "culisanta" ? pricePAS : pricePA,
                        latime: lPoarta,
                        inaltime: hPoarta,
                        latime_pp: latime_pp,
                        buc: 1,
                        suprafata: suprafataPA,
                        cost_modul: costPoarta,
                        cost_total: costPoarta,
                        marja: marja,
                        pret_modul: (
                            Number(costPoarta) +
                            Number(costPoarta) * (marja / 100)
                        ).toFixed(2),
                        min_gol: "10",
                        grosime_rama: FRAME_THICKNESS,
                        tip_poarta_mare: tip_poarta_mare,
                    };
                    arr.push(poartaAObj);
                    nr_crt++;
                }
            }
            return arr;
        },
        getOfferName(country) {
            switch (country) {
                case "at":
                case "de":
                    return "Pulverbeschichteter Aluminiumzaun"
                default:
                    return "gard din aluminiu vopsit electrostatic"
            }
        },
        moveToOferte() {
            const fenceObj = this.getFormatedGardObj(
                this.item.gard_obj,
                this.item.prices,
                this.item.id_cerere,
                this.item.client_obj.judet.price,
            )
            const totalCost = fenceObj.reduce((accumulator, obj) => accumulator + Number(obj.cost_total), 0);

            let newOferta = {
                nume: this.item.client_obj.name ? `${this.item.client_obj.surname} ${this.item.client_obj.name}` : null,
                adresa: "",
                county: this.item.client_obj.judet.text,
                email: this.item.client_obj.email,
                tel: this.item.client_obj.phone,
                date: this.today,
                tip_lucrare: "gard",
                country: this.item.country ? this.item.country : 'ro',
                county_id: this.countyId,
                denumire_lucrare: this.getOfferName(this.item.country),
                noua: 0,
                gard_obj: JSON.stringify(fenceObj),
                color: this.item.gard_obj.color.name,
                cost_fara_tvaG: Number(totalCost),
                val_fara_tvaG: Number(totalCost),
                user_id: this.user.id_user,
                cerere_id: this.item.id_cerere
            };

            // console.log(this.item);
            // console.log(newOferta);
            this.$store.dispatch("moveToOferteGarduri", newOferta);
        },
    }
}
</script>